import React from "react";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import "../css/PostSubMenu.css";
import DeleteIcon from "@material-ui/icons/Delete";
import CreateIcon from "@material-ui/icons/Create";
import Popover from "@material-ui/core/Popover";

import db from "../firebase";

function PostSubMenu({ postId }) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const deletePost = (e) => {
    // console.log(e.target.getAttribute("data-postid"));
    const selectedPost = e.target.getAttribute("data-postid");
    if (window.confirm("Are you sure you wish to delete this item?")) {
      db.collection("posts")
        .doc(selectedPost)
        .delete()
        .then(function () {
          console.log("Document successfully deleted!");
        })
        .catch(function (error) {
          console.error("Error removing document: ", error);
        });
    }
  };

  return (
    <div className="postSubMenu">
      <MoreHorizIcon className="postSubMenu__icon" onClick={handleClick} />

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <div className="postSubMenu__popOver">
          <ul>
            <li>
              <CreateIcon /> Edit post
            </li>
            <li onClick={deletePost} data-postid={postId}>
              <DeleteIcon /> Delete post
            </li>
          </ul>
        </div>
      </Popover>
    </div>
  );
}

export default PostSubMenu;
